<template>
  <form class="needs-validation" novalidate>
    <mdb-input label="사용자 ID" v-model="user.userId" disabled/>
    <mdb-input label="이름*" v-model="user.name"  disabled/>
    <label-text label="성별">{{user.gender}}</label-text>
    <mdb-input label="email*" type="email" v-model="user.email" disabled/>
    <mdb-input label="전화번호*"  :value="cellphone" disabled/>
    <mdb-input label="주소" v-model="user.address"  disabled/>
    <div class="text-center">
      <mdb-btn icon="lock" @click="$router.push({ name:'PasswordChange' })">비밀번호 변경</mdb-btn>
      <mdb-btn icon="check" @click="$emit('mode-change', true)">수정</mdb-btn>
    </div>

  </form>
</template>
<script>
import LabelText from '../common/LabelText.vue';
import { mdbInput, mdbBtn } from 'mdbvue';
import { mapState, mapMutations, mapActions } from 'vuex';
export default {
  name: 'Profile',
  components: { mdbInput, mdbBtn, LabelText },
  props: ['user'],
  computed: {
    cellphone () {
      return this.$cellPhone(this.user.cellPhone)
    }
  },
  methods: {
  }
}
</script>
